import { render } from "./subscribe_project.vue?vue&type=template&id=36fb1cad&scoped=true"
import script from "./subscribe_project.vue?vue&type=script&lang=js"
export * from "./subscribe_project.vue?vue&type=script&lang=js"

import "./subscribe_project.vue?vue&type=style&index=0&id=36fb1cad&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fb1cad"]])

export default __exports__